import { useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { markNotificationAsRead } from 'store/slices/globalSlice';

export const useNotifications = () => {
  const [filter, setFilter] = useState('All');

  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.global.notifications);

  const filteredNotifications = useMemo(() => {
    return (notifications || []).filter((item) => {
      if (filter === 'All') return true;
      return item.status === filter;
    });
  }, [filter, notifications]);

  const handleTabChange = (tab) => {
    setFilter(tab);
  };

  const markAsRead = useCallback(
    (id) => {
      dispatch(markNotificationAsRead(id));
    },
    [dispatch]
  );

  return {
    filter,
    setFilter,
    notifications: filteredNotifications,
    handleTabChange,
    markAsRead,
  };
};
